import {
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import {
  NgbdSortableHeader,
  SortEvent
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { PartsListViewModel } from '../../../business-entities/parts-list-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { PartsBusinessService } from '../../../business-services/parts.service';
import { SettingService } from '../../../business-services/setting.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import { AddPartsComponent } from '../add-parts/add-parts.component';
import { EditPartsComponent } from '../edit-parts/edit-parts.component';
import { BrandService } from '../../../business-services/brand.service';
import { BrandType } from '../../../business-entities/vehicle-list-view-model';
@Component({
  selector: 'app-parts',
  templateUrl: './parts.component.html'
})
export class PartsComponent implements OnInit, OnDestroy {
  dealerList: SelectListItemViewModel;
  selectedDealerId: any;
  dealerSelected: any;
  userRoleRightsDetails: UserRoleMenu;
  partsList: PartsListViewModel[];
  costTypeData = [];
  cost: string = '';
  currentlagSub: Subscription;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  partsSubscription: Subscription;
  makeList: BrandType[] = [];
  brandCode: string = null;
  partNumber: string = "";
  partDescription: string = "";
  tenantId:string = "";
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private partService: PartsBusinessService,
    public settingService: SettingService,
    public cultureLocaleService: CultureLocaleService,
    private userService: UserDataService,
    private modalService: NgbModal,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    config: NgbModalConfig,
    private brandService: BrandService,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = [
      'partNumber',
      'costType',
      'description',
      'unitPrice',
      'comments',
      'isActive'
    ];
    this.pService.searchTerm = '';
    this.costTypeData = [{ id: 1, name: "Personnel" }, { id: 2, name: "Material" }, { id: 3, name: "External" }];
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    this.tenantId = fromEnums.Tenant.AFX;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.DiagnoseTemplate);
    this.pService.dataSource = [];
    if(this.partService.costType && this.partService.isEdit){
      this.cost = this.partService.costType;
    }
    this.partService.isEdit = false;
    this.GetAllMake();
  }
  async GetAllMake(): Promise<void> {
    await this.brandService.GetBrandDropdown().then(data => {
      this.makeList = data.responseObject;
      this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
        this.getParts();
      });
    });
  }
  async getParts() {
    this.spinner.show();
    let model = {
      makeCode: (this.brandCode) ? this.brandCode : "",
      description: (this.partDescription) ? this.partDescription : "",
      no: (this.partNumber) ? this.partNumber : "",
      languageCode:this.cookieservice.get('userSelectedLanguage'),
      dealerId: ""
    }
    await this.partService.getParts(model).then(response => {
      this.pService.dataSource = response;
      this.partsSubscription = this.pService.dealers$.subscribe(result => {
        this.partsList = this.partsDataMapper(result);
      });
      this.spinner.hide();
    },_error => {
      this.spinner.hide();
    });

  }
  private partsDataMapper(parts: PartsListViewModel[]) {
    let supperArray = [];
    if (parts && parts.length > 0) {
      for (let index = 0; index < parts.length; index++) {
        const element = parts[index];

        const single = Object();
        single.id = element.id;
        single.rowNumber = this.currentPageNumber(index);
        single.partNumber = element.partNumber;
        single.costType = element.costType;
        single.description = element.description;
        single.comments = element.comments;
        single.unitPrice = element.unitPrice;
        single.isActive = element.isActive;
        single.editable = (element.tenantId == this.tenantId)?true:false;
        supperArray.push(single);
      }
    }

    return supperArray;
  }
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    } else if (this.pService.page > 1) {
      rtPageNumber =
        Number.parseInt(
          `${this.pService.pageSize * (this.pService.page - 1)}`
        ) +
        (cIndex + 1);
    }

    return rtPageNumber;
  }

  editPartsDetails(partNumber: string,partId:number) {
    this.partService.partNumber = partNumber;
    this.partService.partId = partId;

    const modalref = this.modalService.open(EditPartsComponent, { size: 'lg', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }




  onStatusChange() {
    this.partService.costType = this.cost;
    this.getParts();
  }

  onAdd() {
    const modalref = this.modalService.open(AddPartsComponent, { size: 'lg', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }
  ngOnDestroy(): void {
    if (this.partsSubscription) {
      this.partsSubscription.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
}
